import React from 'react'
import { Image } from 'react-bootstrap';
import lekeTedavisi from '../../images/home/taniTedavi/16001720299480.jpg';
import '../../styles/about.css'

const TaniTedavi2 = () => {
    return (
        <div>
            <h5 className='main-title'>ALLERJİK HASTALIKLAR TANI VE TEDAVİSİ</h5>
            <hr />
            <p><strong>Atopik Dermatit</strong></p>
            <p>
                Atopik dermatit sanayileşmiş toplumlarda önemli bir sağlık sorunu olarak karşımıza çıkarken,
                gelişmekte olan ülkemizde ise sıklığı giderek artış göstermektedir.
            </p>
            <p>
                Atopik dermatit, kronik seyirli, kaşıntılı bir deri hastalığıdır. Her yaşta görülebilmekle birlikte,
                hastaların %90’ında 5 yaşından önce, %50’sinde ikinci aydan sonra başlamaktadır.
                Çocukluk çağının en sık rastlanan kronik deri hastalığıdır.
            </p>
            <p>
                Hastalığın sıklığı ikinci dünya savaşından sonra giderek artmıştır. Sanayileşme, kentleşme ve
                iklim değişiklikleri hastalığın sıklığını etkilemektedir. Ülkemizde ise 6-13 yaş arası çocuklarda %4,3,
                10-11 yaş arası çocuklarda %8,1 oranında görülür.
            </p>
            <p>
                Hastalık çevresel ve genetik faktörlerin etkileşimi sonucu gelişmektedir. Ailede allerji olması
                önemli bir risk faktörüdür. Her iki ebeveynde de allerji varsa risk üç katına çıkmaktadır.
            </p>
            <p>
                Atopik ekzama bebeklik, çocukluk ve erişkin dönemde seyri ve klinik özellikleri ile farklılıklar göstermektedir.
                Bebeklikte daha kızarık, sulantılı, yüz ve kol-bacak dış yüzüne yerleşmiş deri belirtileri varken,
                yaş ilerledikçe deri kalınlaşır, kabalaşır ve renk koyulaşır. Her dönemde deri kuru ve kaşıntılıdır.
                Olguların %20 ile 30’unda iki yaşın sonunda deri lezyonları geriler.
            </p>
            <p>
                Kaşıntı, en önemli bulgudur. Akşama doğru, terleme ve yünlü kıyafetlerin giyilmesiyle artış gösterir.
            </p>
            <p>
                Hastalığın şiddetine, yaşa ve yaygınlığa göre dışardan ilaçlar, ağızdan ilaçlar veya güneş ışınları ile tedavi
                (fototerapi) uygulanabilir. Tedavi edilmezse enfeksiyon eklenebilir.
            </p>
            <p>
                Bebeklik döneminde anne sütünün koruyucu olabileceği düşünülmektedir. Korunmada en önemli nokta alerjen ve
                tahriş edici maddelerden kaçınılmasıdır. Kimyasallar, alkalin sabunlar, ev tozu akarları bunların başında gelmektedir.
                Bu konuda mutlaka hekime danışılmalıdır.
            </p>
            <p>
                Deriyi düzenli nemlendirmek büyük önem taşır. Günlük 10-20 dakikalık ılık banyo sonrası ilk üç dakika içinde derinin
                nemlendirilmesi, derinin bariyer fonksiyonunu ve nem oranını arttırır. Köpük banyolarından ve kokulu banyo tuzlarından
                kaçınılmalıdır. Klorlu havuzlarda yüzülmesi, sıcak jakuzilere girilmesi deride irritasyonu arttırır. Kıyafet olarak yünlü
                ve sentetik kıyafetlerden kaçınılması ve pamukluların giyilmesi önerilmektedir.
            </p>

            <Image src={lekeTedavisi} fluid className='mb-4' style={{ width: '70%' }} />

            <p><strong>Egzamalar</strong></p>
            <p>
                Egzama, çeşitli nedenlerle ortaya çıkan ve deride kızarıklık, şişme, veziküller, kaşıntı gibi belirtilerle görülen daha
                çok psikosomatik nedenli deri hastalığıdır. Başlıca özelliği, kızarık deri üzerinde beliren kabarcıklardır.
            </p>
            <p>
                Ev kadınlarında görülen egzama, çamaşır suyundaki potasyum bikromata, çeşitli çamaşır sularına, hatta lastik eldivenlere bağlıdır.
            </p>
            <p>
                En sık görülen temas egzamalarından biri kozmetiklerden ve saç boyasından (para grubu) ileri gelir. Tırnak cilasının özel bir yeri
                vardır, tırnaklarda egzama yapmaz ama göz kapaklarında yapar.
            </p>

            <p><strong>Ürtiker (Kurdeşen)</strong></p>
            <p>
                Ürtiker, hassasiyet sonucu ortaya çıkan alerjik reaksiyonlar ile deride döküntüler ve kaşıntı ile kendini gösteren bir durumdur.
            </p>

            <p><strong>Allerjik Rinit</strong></p>
            <p>
                İltihaplı ve çok hızlı çoğalan deri hastalıklarının tedavisinde, farklı ışık tedavileri yıllardır başarı ile kullanılmaktadır.
                Ancak burun mukozasının iltihaplı hastalıklarından biri olan alerjik riniti tedavi edebilen en etkili metotlardan biri medikal fototerapidir.
                Medikal fototerapi (Rhinolight), burun içerisine yapılan bir ışık tedavisidir. Burun içi medikal fototerapi, alerji yaratan etkenlerin,
                nasıl belirtiler verdiğine bakılmaksızın, alerjik burun akıntısının tedavisi için geliştirilmiştir.
            </p>

            <p>
                Medikal fototerapi, nazal mukozanın bu ışığa maruz bırakılması, alerjik rinitin birçok belirtilerini azaltır ya da sona erdirir.
                Bu ağrısız tedavi yöntemi, sadece birkaç dakika sürmektedir. Hastaların yaşam kalitesi, uygulanan fototerapi sayesinde bir ya da iki tedaviden
                hemen sonra daha iyi hale gelmektedir. Hem mevsimsel hem de tüm yıl süren alerjik nezlesi olan hastalarda ışık tedavisi ile burunda alerjiye
                ağlı gelişen kaşıntı, akıntı, tıkanma, hapşırık gibi her türlü şikâyet başarı ile azaltılmakta ya da yok edilmektedir.
            </p>

            <p><strong>İlaç Allerjileri</strong></p>
            <p>
                Hastalıkların tanı ve tedavileri için ard arda geliştirilen ilaçlarla birlikte bunlarla oluşan alerjik reaksiyonların da görülme sıklığında
                maalesef ki ciddi artışlar olmuştur.
            </p>

            <p>
                Aslında ilaçların çoğu kendi başlarına alerjik etkili değildirler. Ancak; vücuda girdiğinde bir takım proteinlerle birleşip alerjik etkinlik kazanırlar.
                Bunun dışında bir çok ilacın üretimi esnasında kullanılan boya ve koruyucu maddeler de alerjik reaksiyonlardan sorumlu olabilirler.
            </p>

            <p>
                İlaç alerjileri bilimsel verilere göre sık görülen reaksiyonlar değildirler. Buna rağmen ilaç alerjisi tanısı alan o kadar çok hasta vardır ki; bu alerjik
                reaksiyonları olduğunu zanneden bir çok hasta ile karşılaşabiliyoruz. Buradaki problem hastaların ilaçlarla ortaya çıkan hemen tüm yan etki reaksiyonlarının
                ilaç alerjisine bağlanması olabilir. Ancak; gerçek ilaç alerjilerinin bir takım özellikleri vardır. Bunu değerlendirecek olan ise mutlak ve mutlak bir alerji
                ve immünoloji uzmanıdır. Örneğin; Amerika’ da hiç de az sayılmayacak bir hasta sayısı ile (36 653 hastada) yapılan bir araştırmada % 1.67 oranında ilaçlarla
                ilgili yan etki saptanmışken, bunların sadece % 10’ unun gerçek ilaç alerjisi olduğu görülmüştür. Yine tüm bu hastaların sadece 8 tanesinde alerjik reaksiyon
                hayatı tehdit edici tarzda bulunmuştur.
            </p>

        </div>
    )
}

export default TaniTedavi2